import LoginHistory from '../Security/LoginHistory';
import MultiFactorAuth from '../Security/MultiFactorAuth';
import ChangePasswordForm from '../Security/ChangePasswordForm';

import "../../assets/style/Security.css"

export default function SecurityPage() {
  return (
    <div className="security-page-container">
      <div className="security-grid">
        <MultiFactorAuth />
        <ChangePasswordForm />
      </div>
      <LoginHistory />
    </div>
  );
}
